import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { Badge, Form } from "reactstrap";
import { createUserAPI, getUserListAPI, updateUserAPI } from "../../api/user";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import useLogout from "../../Hooks/Logout";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import MyButton from "../../MyComponents/Form/MyButton";
import MyInput from "../../MyComponents/Form/MyInput";
import ConfirmModal from "../../MyComponents/Modal/ConfirmModal";
import ApiPaginationDataTable from "../../MyComponents/MyTables/ApiPaginationDataTable";
import { decrypt, formatDateTimeIST, hasAdminPermission } from "../../utils/Utils";
import "./user-table-actions.scss";

const User = () => {
  const canView = hasAdminPermission("users.view");
  const canMutate = hasAdminPermission("users.create");
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 
  const navigate= useNavigate()
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [totalRows, setTotalRows] = useState(0);
    // Change Page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const logout=useLogout()
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      limit: 25,
      server_search: "",
      isLoading: true,
      topProductLoading: true,
      tableLoading: true,
    },
  });
   const limit = watch("limit");
     // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(Number(newPerPage)) ? itemPerPage : newPerPage;
    setItemPerPage(rows);
    setValue("page", page);
  };
  const handlePageChange = (page) => {
    setValue("page", page);
  };
  const serverSearchInput = watch("server_search") ?? "";

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(serverSearchInput.trim());
    }, 450);
    return () => clearTimeout(handler);
  }, [serverSearchInput]);

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter]);
  const [columns,setColumns]=useState([
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Mobile",
      selector: (row) => row?.phone,
      sortable: true,
    },
    {
      name: "Source",
      selector: (row) => row?.registration_source || "—",
      maxWidth: "120px",
      wrap: true,
    },
    {
      name: "Country",
      selector: (row) => row?.signup_country || "—",
      wrap: true,
    },
    {
      name: "State / region",
      selector: (row) => row?.signup_region || "—",
      wrap: true,
    },
    {
      name: "City",
      selector: (row) => row?.signup_city || "—",
      wrap: true,
    },
    {
      name: "IP",
      selector: (row) => row?.signup_ip || "—",
      maxWidth: "130px",
      wrap: true,
    },
    {
      name: "Created At (IST)",
      selector: (row) => formatDateTimeIST(row?.created_at),
      sortable: true,
    },
  {
  name: "Status",
  selector: (row) => row?.status,
  cell: (row) => (
    <div style={{ cursor: canMutate ? "pointer" : "default" }} onClick={() => handleToggleStatus(row)}>
      <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
    </div>
  ),
  sortable: true,
  wrap: true,
},

    {
      name: "Action",
      wrap: false,
      center: true,
      minWidth: "148px",
      maxWidth: "200px",
      cell: (row) => (
        <div className="user-table-actions user-table-actions--in-cell">
          {canMutate ? (
            <button
              type="button"
              className="user-table-actions__btn user-table-actions__btn--edit"
              title="Edit user"
              aria-label="Edit user"
              onClick={() => handleEdit(row)}
            >
              <Icon name="edit" />
            </button>
          ) : null}
          <button
            type="button"
            className="user-table-actions__btn user-table-actions__btn--view"
            title="View questions requested by this user"
            onClick={() => handleView(row)}
          >
            <Icon name="eye" />
            <span>Questions</span>
          </button>
          {!canMutate ? <span className="text-soft small"> </span> : null}
        </div>
      ),
    },
  ])
  useEffect(() => {
    const body = {
      search: debouncedSearch,
      page: watch("page")||1,
      limit: itemPerPage,
      ...(statusFilter === "active" ? { status: true } : {}),
      ...(statusFilter === "inactive" ? { status: false } : {}),
    };
    getUser(body);
  }, [itemPerPage, currentPage, debouncedSearch, statusFilter, watch("page")]);

  const getUser = (data) => {
    setIsLoading(true)
    getUserListAPI(data)
      .then((res) => {
        // decrypt data
        console.log("res", res.data.data); 
        const status = res.data.status;
        if (status === true) {
          const decryptedResponse = res.data.data;
          setValue("limit", decryptedResponse?.pagination?.total);
          setTotalRows(decryptedResponse?.pagination?.total ?? 0);
          setData(decryptedResponse?.items);
          toast.clearWaitingQueue();
          setIsLoading(false)
        } else if (status === false) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
          setTotalRows(0);
          setIsLoading(false)
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false)
        console.error(err);
      });
  };
    const handleToggleStatus = (row) => {
    if (!canMutate) return;
    setValue("selectedRow",row);
    setShowModal(true);
  };
  const handleEdit =(row)=>{
    
    console.log(row,"aaaaaaa")
    setValue("selectedRow",row)
    setValue("user",row?.username)
    setValue("password",row?.password||"")
    setIsOpen(true)
    setMode("Edit")
  }
  const onFormSubmit = (data) => {
    const body = {
      username: watch("user"), 
      password:watch("password"),
      ...(mode == "Edit" && { user_id: watch("selectedRow")?.user_id }),
    };
    const bod = {
      search: debouncedSearch,
      page: currentPage,
      limit: itemPerPage,
      ...(statusFilter === "active" ? { status: true } : {}),
      ...(statusFilter === "inactive" ? { status: false } : {}),
    };
    if (mode == "Add") {
      createUserAPI(body)
        .then((res) => { 
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getUser(bod);
            reset();
            setIsOpen(false); 
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err.message);
        });
    }
       if (mode == "Edit") {
      updateUserAPI(body)
        .then((res) => { 
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getUser(bod);
            reset();
            setIsOpen(false); 
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err.message);
        });
    }

  };
const confirmStatusChange = (isActivate) => {
  const updatedStatus = isActivate ? true : false;  
  const userId = watch("selectedRow").user_id;

  // Optimistically update the status in the data array
  setData((prevData) => {
    return prevData.map((user) =>
      user.user_id === userId ? { ...user, status: updatedStatus } : user
    );
  });

  // Prepare the request body for status update
  const formObject = {
    user_id: userId,
    status: updatedStatus,
  };

  // Send the API request to update the status
  updateUserAPI(formObject)
    .then((res) => {
      const status = decrypt(res.data.status);
      
      if (status === true) {
        toast.success(res.data.message);
        setShowModal(false);  
      } else if (status === false) {
        toast.error(res.data.message);
        setShowModal(false);  
      } else if (status === "expired") {
        toast.error(res.data.message);
        logout();
      }
    })
    .catch((err) => {
      console.error("Error updating status:", err);
      toast.error("Something went wrong. Please try again.");
    });
};
const handleView=(row)=>{  
  navigate("/requested-questions-by-user",{ state: { data: row } })
}
  const clearReportFilters = () => {
    setValue("server_search", "");
    setStatusFilter("all");
    setCurrentPage(1);
  };

  const activeFilterSummary =
    statusFilter !== "all" || (serverSearchInput && serverSearchInput.trim().length > 0)
      ? `Filters: ${statusFilter !== "all" ? `status = ${statusFilter}` : "all statuses"}${serverSearchInput?.trim() ? ` · search “${serverSearchInput.trim()}”` : ""}`
      : null;

  return (
    <>
      <Head title={"Users"} />
      <Content>
        {!canView ? (
          <BlockHead size={`sm`}>
            <BlockBetween>
              <BlockHeadContent>
                <BlockTitle page tag="h3">
                  Manage User
                </BlockTitle>
                <BlockDes className="text-soft mb-0">Permission denied: <code>users.view</code></BlockDes>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
        ) : null}
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage User"}
              </BlockTitle>
              <BlockDes className="text-soft">Search, filter by status, and export registered accounts.</BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                {canMutate ? (
                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    onClick={() => {
                      setIsOpen((pre) => !pre);
                      setMode("Add");
                      reset();
                    }}
                  >
                    <Icon name={isOpen ? "minus" : "plus"} />
                  </Button>
                ) : null}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <>
            {isOpen && (
              <>
                {" "}
                <PreviewAltCard>
                  <Form onSubmit={handleSubmit(onFormSubmit)}>
                   <Row>

                     <Col md="6" className={``}>
                      <MyInput
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title={"User"}
                        name={"user"}
                        placeholder={"Enter user name"}
                        required
                        min={2}
                        max={50}
                        inputPattern={/[^A-Za-z\s]/g}
                        pattern={/^(?!\s*$)[a-zA-Z /.]*$/}
                        patternMsg={"Only alphabets are allowed"}
                      />
                    </Col>
                    <Col md="6" className={``}>
                      <MyInput
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title={"Password"}
                        name={"password"}
                        placeholder={"Enter user password"}
                       required={mode=="Add"} 
                        min={2}
                        max={50}
                        // inputPattern={/[^A-Za-z\s]/g}
                        pattern={/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/}
                        patternMsg={"Minimum length of 8 characters, only allowing letters, digits, and special characters"}
                      />
                    </Col>
                    <MyButton isLoading={isLoading} mode={mode}/>
                   </Row>
                  </Form>
                </PreviewAltCard>
              </>
            )}

          </>
          {/* <MyDataTable data={data} columns={columns} title={"Users"} isLoading={isLoading}/> */}
          <ApiPaginationDataTable
            data={data}
            limit={limit}
            totalRows={totalRows}
            setItemPerPage={setItemPerPage}
            itemPerPage={itemPerPage}
            perPage={itemPerPage}
            paginate={paginate}
            currentPage={currentPage}
            columns={columns}
            title={"Registered Users"}
            subtitle="Use search and status filters to narrow the list. Export applies to the current result set."
            isLoading={isLoading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            serverSearch
            paginationServer
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            expA
            expKeys={[
              "name",
              "phone",
              "registration_source",
              "signup_ip",
              "signup_country",
              "signup_region",
              "signup_city",
              "created_at",
              "status",
            ]}
            fileName={"registered-users"}
            searchPlaceholder="Search by name or mobile…"
            statusFilter={statusFilter}
            onStatusFilterChange={setStatusFilter}
            showStatusFilter
            onClearFilters={clearReportFilters}
            activeFilterSummary={activeFilterSummary}
          />
        </Block>
      </Content>
       {/* Confirmation Modal */}
       <ConfirmModal
  isOpen={showModal}
  toggle={() => setShowModal(!showModal)} 
  onConfirm={confirmStatusChange} 
  status={watch("selectedRow")?.status} 
/>

    </>
  );
};

export default User;